module.exports = __webpack_public_path__ + "images/default_avatars/path-3f82c5fb6278850f405da3238887528f.jpg";